import React from 'react';
import PropTypes from 'prop-types';
import { StyledSectionIntro, Header, Subheader } from './styles.js';

export const SectionIntro = ({
  headline = null,
  subheadline,
  maxWidth = null,
  typography = 'heading2',
  fontColor,
  textAlignment = 'center',
  headingLevel = 'h2',
}) => {
  return (
    <StyledSectionIntro
      maxWidth={maxWidth}
      $fontColor={fontColor}
      $textAlignment={textAlignment}
    >
      {headline && (
        <Header $typography={typography} as={headingLevel}>
          {headline}
        </Header>
      )}
      {subheadline && (
        <Subheader $fontColor={fontColor}>
          {typeof subheadline === 'string' ? (
            <span>{subheadline}</span>
          ) : (
            subheadline
          )}
        </Subheader>
      )}
    </StyledSectionIntro>
  );
};
SectionIntro.displayName = 'SectionIntro';

SectionIntro.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  maxWidth: PropTypes.number,
  fontColor: PropTypes.string,
  textAlignment: PropTypes.oneOf(['left', 'center', 'right']),
  headingLevel: PropTypes.string,
  typography: PropTypes.string,
};
